<template>
    <div class="nav">
        <div class="top">
            <div class="display-type">
                <button class="little" :class="{'selected': display == 'little'}" @click="displaySwapp('little')">
                    <img src="@/assets/img/top_menu/view_small_empty.png" alt="view small products">
                </button>
                <button class="medium" :class="{'selected': display == 'medium'}" @click="displaySwapp('medium')">
                    <img v-if="display == 'medium'" src="@/assets/img/top_menu/view_medium.png" alt="view medium products">
                    <img v-else src="@/assets/img/top_menu/view_medium_empty.png" alt="view medium products">
                </button>
                <button class="big" :class="{'selected': display == 'big'}" @click="displaySwapp('big')">
                    <img src="@/assets/img/top_menu/view_large_empty.png" alt="view large products">
                </button>
                <button class="single" :class="{'selected': display == 'single'}" @click="displaySwapp('single')">
                    <img v-if="display == 'single'" src="@/assets/img/top_menu/view_one.png" alt="view one products">
                    <img v-else src="@/assets/img/top_menu/view_one_empty.png" alt="view one products">
                </button>
                <span>[<span v-if="display == 'single'">{{ currentId + 1 }}/</span>{{products.length}}]</span>
            </div>

            <div class="right" :class="{'hidden': display == 'single'}">
                <button class="chat">
                    <img src="@/assets/img/top_menu/chat_top.png" alt="chat button">
                </button>
                <button class="heart">
                    <img src="@/assets/img/top_menu/heart_top.png" alt="Like icon">
                </button>
                <button class="share">
                    <img src="@/assets/img/top_menu/share_top.png" alt="share button">
                </button>
                <button class="bookmark">
                    <img src="@/assets/img/top_menu/bookmark_top.png" alt="chat button">
                </button>
            </div>
        </div>

        <div class="search" :class="{'hidden': display == 'single'}">
            <div>
                <span class="tag"><p>In</p></span>
                <span class="tag"><p>Out</p></span>
                <span class="tag"><p>Music</p></span>
            </div>

            <div class="right">
                <ul>
                    <li><p class="low">SORT BY TAG</p></li>
                    <li><p class="low" @click="infoSwapp"><span v-if="!showInfos">SHOW</span><span
                            v-if="showInfos">HIDE
                    </span> INFO</p></li>
                    <li><p>Trend</p></li>
                    <li><p @click="showStyleSearch = !showStyleSearch">Style</p></li>
                    <li><p>Feeling</p></li>
                    <li><p>Range</p></li>
                    <li><p>Product</p></li>
                    <li><p>Brand</p></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "HomeNav",
        data() {
            return {
                searchs: [],
                showStyleSearch: false,
            }
        },
        props: {
            products: Array,
            display: String,
            currentId: Number,
            showInfos: Boolean,
        },
        methods: {
            infoSwapp(){
                let newInfoStatus = this.showInfos
                newInfoStatus = !newInfoStatus
                this.$emit("update-infos", newInfoStatus);
            },
            displaySwapp(display){
                let newDisplay = this.display
                newDisplay = display
                this.$emit("update-display", newDisplay);
            }
        }
    }
</script>

<style scoped lang="scss">
    .nav{
        position: fixed;
        top: 0;
        width: calc(100% - 30px);
        padding-left: 10px;
        color: #193131;
        background-color: #fff;
        text-transform: uppercase;
        box-sizing: border-box;
        z-index: 100;

        .top{
            display: flex;
            justify-content: center;
            align-items: center;

            button{
                border: 0;
                background: transparent;
                cursor: pointer;
            }

            .display-type{
                width: 20%;
                display: block;
                margin: auto;
                text-align: center;
                padding-top: 5px;

                span{
                    font-size: 15px;
                    font-family: Roboto,sans-serif;
                    font-style: italic;
                    letter-spacing: 2px;
                    margin: 0 0 0 3px;
                    padding: 0;
                    color: #5b7571;
                    vertical-align: top;
                }

                button {
                    padding: 0;
                    width: 20px;
                    margin-right: 5px;

                    img{
                        height: 16px;
                    }
                }
            }

            .right{
                justify-self: end;
                margin-right: 10px;

                button{
                    font-size: 16px;
                    width: 30px;
                    padding: 5px 5px 0;

                    img{
                        height: 17px;
                    }
                }
            }
        }

        .search{
            display: flex;
            justify-content: space-between;
            width: 100%;
            border-width: 1px 0;
            border-style: solid;
            border-color: #b5c6c1;
            overflow: hidden;

            .tag {
                font-family: Refrigerator;
                font-size: 13px;
                font-weight: 700;
                display: inline-block;
                margin: 2px;
                padding: 2px 10px;
                color: #b1c4bf;
                background-color: var(--main-green);
                transform: skewX(-5deg);
                cursor: pointer;

                *{
                    transform: skewX(5deg);
                }

                p{
                    display: inline-block;
                    margin: 0;
                }
            }

            .right{
                margin-right: 10px;

                ul {
                    height: 100%;
                    margin: 0;
                    padding-left: 0;
                    list-style: none;

                    li {
                        display: inline-block;
                        height: 100%;
                        border-width: 0 1px 0 0;
                        border-style: solid;
                        border-color: #b1c4bf;
                        padding: 4px;
                        color: #b5c6c1;
                        cursor: pointer;
                        transform: skewX(-5deg);
                        user-select: none;

                        &:first-child {
                            border-width: 0 1px 0 1px;
                        }

                        p {
                            font-family: Refrigerator;
                            font-size: 14px;
                            font-weight: 700;
                            margin: 0;
                            padding: 0 8px;
                            letter-spacing: 1px;
                            transform: skewX(5deg);

                            &.low {
                                font-size: 12px;
                                line-height: 18px;
                                color: #5b7671;
                                font-weight: 400;
                            }
                        }
                    }
                }
            }
        }

    }
</style>
